/**
 * Estado del espacio de trabajo (el tenant), para la interfaz.
 *
 * Vive acá y no en `AppLayout` para poder probarlo sin arrastrar el árbol de
 * stores del layout.
 */

const ESTADOS_DEL_TENANT: Record<string, string> = {
  inactive:     'desactivado',
  suspended:    'suspendido',
  provisioning: 'en aprovisionamiento',
}

/**
 * Cómo se llama el estado del espacio de trabajo cuando NO está activo.
 *
 * Devuelve `null` si está activo, o si todavía no se sabe — así el banner no
 * parpadea en la primera carga. Un estado que no conocemos se muestra tal cual en
 * vez de silenciarse: el aviso importa más que la etiqueta, y `Tenant.Status`
 * puede ganar valores nuevos.
 */
export function etiquetaDeEstadoInactivo(estado?: string | null): string | null {
  if (!estado || estado === 'active') return null
  return ESTADOS_DEL_TENANT[estado] ?? estado
}
